// Staff view - main staff tools with tabbed navigation

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';
import { router } from '../../lib/router.js';

// Import staff sub-views
import './staff-users-view.js';
import './staff-invitations-view.js';
import './staff-games-view.js';
import './staff-adventures-view.js';
import './staff-equipment-view.js';
import './staff-classes-view.js';
import './staff-backgrounds-view.js';
import './staff-feats-view.js';
import './staff-species-view.js';
import './staff-spells-view.js';
import './staff-weapon-masteries-view.js';
import './staff-monsters-view.js';
import './staff-paperdoll-view.js';
/**
 * Main staff view component with tabbed navigation
 */
class StaffView extends BaseComponent {
  static properties = {
    activeTab: { type: String, attribute: 'active-tab' },
  };

  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .tab-content {
      position: relative;
      flex: 1;
      min-height: 0;
    }
  `;

  constructor() {
    super();
    this.activeTab = 'users';
  }

  /**
   * @param {Event} e
   * @param {string} tab
   */
  _navigateTab(e, tab) {
    e.preventDefault();
    router.navigate(`/staff/${tab}`);
  }

  render() {
    return html`
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="h2 mb-0">Staff Tools</h1>
        <a
          href="#"
          class="btn btn-outline-secondary px-4 py-2"
          @click="${
            /** @param {Event} e */ (e) => {
              e.preventDefault();
              router.navigate('/');
            }
          }"
          >Exit Staff</a
        >
      </div>

      <ul class="nav nav-tabs mb-4 flex-wrap">
        <li class="nav-item">
          <a
            href="/staff/users"
            class="nav-link ${this.activeTab === 'users' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'users')}"
          >
            Users
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/invitations"
            class="nav-link ${this.activeTab === 'invitations' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'invitations')}"
          >
            Invitations
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/games"
            class="nav-link ${this.activeTab === 'games' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'games')}"
          >
            Games
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/adventures"
            class="nav-link ${this.activeTab === 'adventures' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'adventures')}"
          >
            Adventures
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/equipment"
            class="nav-link ${this.activeTab === 'equipment' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'equipment')}"
          >
            Equipment
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/classes"
            class="nav-link ${this.activeTab === 'classes' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'classes')}"
          >
            Classes
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/backgrounds"
            class="nav-link ${this.activeTab === 'backgrounds' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'backgrounds')}"
          >
            Backgrounds
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/feats"
            class="nav-link ${this.activeTab === 'feats' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'feats')}"
          >
            Feats
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/species"
            class="nav-link ${this.activeTab === 'species' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'species')}"
          >
            Species
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/spells"
            class="nav-link ${this.activeTab === 'spells' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'spells')}"
          >
            Spells
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/weapon-masteries"
            class="nav-link ${this.activeTab === 'weapon-masteries' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'weapon-masteries')}"
          >
            Weapon Masteries
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/monsters"
            class="nav-link ${this.activeTab === 'monsters' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'monsters')}"
          >
            Monsters
          </a>
        </li>
        <li class="nav-item">
          <a
            href="/staff/paperdoll"
            class="nav-link ${this.activeTab === 'paperdoll' ? 'active' : ''}"
            @click="${/** @param {Event} e */ (e) => this._navigateTab(e, 'paperdoll')}"
          >
            Paper Doll Proto
          </a>
        </li>
      </ul>

      <div class="tab-content">
        ${this.activeTab === 'users' ? html`<staff-users-view></staff-users-view>` : ''}
        ${this.activeTab === 'invitations' ? html`<staff-invitations-view></staff-invitations-view>` : ''}
        ${this.activeTab === 'games' ? html`<staff-games-view></staff-games-view>` : ''}
        ${this.activeTab === 'adventures' ? html`<staff-adventures-view></staff-adventures-view>` : ''}
        ${this.activeTab === 'equipment' ? html`<staff-equipment-view></staff-equipment-view>` : ''}
        ${this.activeTab === 'classes' ? html`<staff-classes-view></staff-classes-view>` : ''}
        ${this.activeTab === 'backgrounds' ? html`<staff-backgrounds-view></staff-backgrounds-view>` : ''}
        ${this.activeTab === 'feats' ? html`<staff-feats-view></staff-feats-view>` : ''}
        ${this.activeTab === 'species' ? html`<staff-species-view></staff-species-view>` : ''}
        ${this.activeTab === 'spells' ? html`<staff-spells-view></staff-spells-view>` : ''}
        ${this.activeTab === 'weapon-masteries' ? html`<staff-weapon-masteries-view></staff-weapon-masteries-view>` : ''}
        ${this.activeTab === 'monsters' ? html`<staff-monsters-view></staff-monsters-view>` : ''}
        ${this.activeTab === 'paperdoll' ? html`<staff-paperdoll-view></staff-paperdoll-view>` : ''}
      </div>
    `;
  }
}

customElements.define('staff-view', StaffView);
